export default __webpack_public_path__ + "static/media/task-completed.187ae8e3.png";